import {InputNumber, Modal, Row, Col, Checkbox} from 'antd';
import {useState} from "react";

export const AlertWidget = ({alertQuantity, enableAlert, onChange, props, children}) => {
    const [isOpen, setOpen] = useState(false);
    const [quantity, setQuantity] = useState(alertQuantity);
    const [enable, setEnable] = useState(enableAlert);

    const onOpen = () => {
        setOpen(true);
    }

    const onOk = () => {
        setOpen(false)
        if (onChange) {
            onChange(quantity, enable)
        }
    }

    const onCancel = () => {
        setOpen(false);
    }

    const onInputChange = (val) => {
        console.log(val);
        setQuantity(val);
    }

    const onEnableChange = (e) => {
        setEnable(e.target.checked);
    }

    return <div>
        <div style={{cursor: 'pointer', color: "#108ee9"}} onClick={onOpen}>{children}</div>
        <Modal width={400} open={isOpen} onOk={onOk} onCancel={onCancel}>
            <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col><InputNumber style={{width: 300}} precision={0} onChange={onInputChange} value={quantity} /></Col>
            </Row>
            <Row>
                <Col style={{marginRight: '5px'}}><b>Enable: </b></Col>
                <Col><Checkbox onChange={onEnableChange} checked={enable} /></Col>
            </Row>
        </Modal>
    </div>
}